import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { StudioPage } from './studio.page';
import { SquadCastComponentsModule } from '../../components/squadcast.components.module';
import { SessionResolverService } from '../../services/session-resolver/session-resolver.service';
import { GuestService } from '../../services/guest/guest.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild([
      {
        path: ':showID/session/:sessionID',
        component: StudioPage,
        resolve: { session: SessionResolverService },
        canActivate: [GuestService],
      },
      {
        path: ':showID/session/:sessionID/guest/:guestEmail',
        component: StudioPage,
        resolve: { session: SessionResolverService },
        canActivate: [GuestService],
      },
      {
        path: ':showID/session/:sessionID/location/:location',
        component: StudioPage, // UPDATE TO BACKSTAGE
        resolve: { session: SessionResolverService },
        canActivate: [GuestService],
      },
      {
        path: ':showID/session/:sessionID/location/:location/:guestEmail',
        component: StudioPage, // UPDATE TO BACKSTAGE
        resolve: { session: SessionResolverService },
        canActivate: [GuestService],
      },
    ]),
    SquadCastComponentsModule,
  ],
  declarations: [StudioPage],
  providers: [SessionResolverService],
})
export class StudioPageModule {}
